import type { FC } from 'react';

import { IconButtonWithTooltip, Icons, TooltipPositions } from '../../../controls/iconButton/IconButtonWithTooltip';

interface SettingsControlPlainProps {
  condition: boolean;
  onClick: () => void;
}

export const SettingsControlPlain: FC<SettingsControlPlainProps> = ({ condition, onClick }) => {
  return (
    <IconButtonWithTooltip
      data-testid="settings-button"
      icon={Icons.Settings}
      active={condition}
      onClick={onClick}
      tooltipOptions={{
        text: 'SETTINGS',
        position: TooltipPositions.Bottom,
      }}
    />
  );
};
